import React from 'react';
import PropTypes from 'prop-types';

import TransactionPresenter from '../../../../presenters/TransactionPresenter';

import TransactionsTable from './components/TransactionsTable';

const Transactions = (props) => {
  const { transactions, loadingState, meta, onPageChange } = props;

  return (
    <div>
      <div className="form-header">
        <h4>Transactions</h4>
      </div>
      <TransactionsTable
        transactions={transactions}
        loadingState={loadingState}
        meta={meta}
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default Transactions;

Transactions.propTypes = {
  transactions: PropTypes.arrayOf(TransactionPresenter.shape()),
  meta: PropTypes.shape().isRequired,
  onPageChange: PropTypes.func.isRequired,
  loadingState: PropTypes.string.isRequired,
};

Transactions.defaultProps = {
  transactions: [],
};
